import { API_URL, UrlProperties, getBranchId, getToken, handleResponse } from './helpers';

const storedToken = getToken();
const storedBranchId = getBranchId();
let token = storedToken ? JSON.parse(storedToken)?.access_token : '';
let branchId = storedBranchId ?? '';

interface TokenObject {
	access_token: string;
	refresh_token: string;
}

export const setToken = (tokenData: TokenObject | string) => {
	if (typeof tokenData === 'string') {
		token = tokenData;

		if (tokenData === '') {
			localStorage.removeItem('token');
			localStorage.removeItem('refresh-token');
			localStorage.removeItem('originalToken');
			localStorage.removeItem('originalRefreshToken');
		}
	} else {
		token = tokenData.access_token;
		localStorage.setItem('token', JSON.stringify(tokenData));
		localStorage.setItem('refresh-token', tokenData.refresh_token);
	}
};

export const setImpersonationToken = (tokenData: TokenObject) => {
	const currentToken = localStorage.getItem('token');
	const currentRefreshToken = localStorage.getItem('refresh-token');
	if (currentToken) localStorage.setItem('originalToken', currentToken);
	if (currentRefreshToken) localStorage.setItem('originalRefreshToken', currentRefreshToken);

	setToken(tokenData);
};

export const stopImpersonation = () => {
	const originalToken = localStorage.getItem('originalToken');
	const originalRefreshToken = localStorage.getItem('originalRefreshToken');

	if (originalToken) {
		localStorage.setItem('token', originalToken);
		const parsed = JSON.parse(originalToken);
		token = parsed.access_token;
	}
	if (originalRefreshToken) {
		localStorage.setItem('refresh-token', originalRefreshToken);
	}

	localStorage.removeItem('originalToken');
	localStorage.removeItem('originalRefreshToken');
};

export const isImpersonating = () => {
	return Boolean(localStorage.getItem('originalToken'));
};


export const setBranchId = (id: string) => {
	branchId = id;
	localStorage.setItem('branchId', id);
};

export const FetchAPI = {
	getJson: async ({ urlStr }: UrlProperties): Promise<any> => {
		const response = await fetch(`${API_URL}${urlStr}`, {
			headers: {
				Authorization: `Bearer ${token}`,
				'X-Branch-Id': branchId,
			},
		});

		return await handleResponse({ response, urlStr, method: 'getJson' });
	},
	postJson: async ({ urlStr, data }: UrlProperties): Promise<any> => {
		const response = await fetch(`${API_URL}${urlStr}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
				'X-Branch-Id': branchId,
			},
			body: JSON.stringify(data),
		});

		return await handleResponse({ response, urlStr, data, method: 'postJson' });
	},
	post: async ({ urlStr, data }: { data: any; urlStr: string }): Promise<any> => {
		const response = await fetch(`${API_URL}${urlStr}`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${token}`,
				'X-Branch-Id': branchId,
			},
			body: data,
		});

		return await handleResponse({ response, urlStr, data, method: 'post' });
	},
	putJson: async ({ urlStr, data, signal }: UrlProperties): Promise<any> => {
		const response = await fetch(`${API_URL}${urlStr}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
				'X-Branch-Id': branchId,
			},
			body: JSON.stringify(data),
			signal,
		});

		return await handleResponse({ response, urlStr, data, method: 'putJson' });
	},
	deleteJson: async ({ urlStr, data }: UrlProperties): Promise<any> => {
		const response = await fetch(`${API_URL}${urlStr}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
				'X-Branch-Id': branchId,
			},
			body: JSON.stringify(data),
		});

		return await handleResponse({
			response,
			urlStr,
			data,
			method: 'deleteJson',
		});
	},
};
